import { createContext } from 'react';
import { IAuthState } from './types';
import { authInitialState } from './reducer';

const AuthContext = createContext<IAuthState>(authInitialState);

export default AuthContext;
